import { zodResolver } from "@hookform/resolvers/zod";
import { type DefaultValues, type FieldValues, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import type { z } from "zod";

type MutateFn<TOutput> = (
	data: TOutput,
	options: {
		onSuccess: () => void;
	},
) => void;

type Args<TInput extends FieldValues, TOutput> = {
	schema: z.ZodType<TOutput, z.ZodTypeDef & { typeName: string }, TInput>;
	defaultValues: DefaultValues<TInput>;
	mutate: MutateFn<TOutput>;
	successRoute: string;
};

export const useCreatePortfolioForm = <TInput extends FieldValues, TOutput>({
	schema,
	defaultValues,
	mutate,
	successRoute,
}: Args<TInput, TOutput>) => {
	const navigate = useNavigate();

	const form = useForm<TInput, unknown, TOutput>({
		resolver: zodResolver(schema),
		defaultValues,
		mode: "onChange",
	});

	const onSubmit = form.handleSubmit((data) => {
		mutate(data, {
			onSuccess: () => {
				navigate(successRoute, { replace: true });
			},
		});
	});

	return { form, onSubmit };
};
